import { isPro, isClient } from '~~/utils/index'

export default (error: any) => {
  const config = useRuntimeConfig()
  if (!isPro(config.public.env.NODE_ENV) && !isClient()) {
    import('./logger.config').then(({ errorLog }) => {
      if (!error.response) {
        errorLog.info(
          `[Request Failed]：${JSON.stringify({
            request: error.request,
            errorMessage: error?.error?.message,
            errorStack: error?.error?.stack,
            ...error.options,
          })}`,
        )
      } else {
        errorLog.info(
          `[Reponse Error]：${JSON.stringify({
            request: error.request,
            status: error.response.status,
            statusText: error.response.statusText,
            response: error.response._data,
          })}`,
        )
      }
    })
  }
}
